let elementName = `nss-buybox-sticky-atc-variant`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxStickyATC extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    init() {
      this.els = {
        qtyItems: this.querySelectorAll(`[nss-sticky-qty-item-count]`),
        frequencyItems: this.querySelectorAll(`[nss-frequency-update]`),
        atcBtn: this.querySelector(`[nss-add-to-cart-btn]`),
      };

      this.variantId = this.getAttribute(`nss-variant-id`);
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Sticky ATC] Connected.`);

      // Portal to <body>: inside the section the bar sits under the hero's
      // stacking contexts (.nss-hero__wrapper z-1, first-child nss-hero-pdp
      // z-3), which cap its fixed z-index below other fixed bars — Safari
      // paints that per spec, so the bar ends up under later sections. The
      // empty <nss-buybox-sticky-atc> wrapper stays in the section, so
      // section re-renders still swap in a fresh bar; the fresh bar removes
      // the previous portaled one here on connect.
      if (this.parentElement !== document.body) {
        this.sectionEl = this.closest(`[id^="shopify-section"]`);
        const sid = this.getAttribute(`nss-parent-section-id`);
        document
          .querySelectorAll(`body > nss-buybox-sticky-atc-variant[nss-parent-section-id="${sid}"]`)
          .forEach((el) => el.remove());
        document.body.appendChild(this);
        return; // connectedCallback re-fires with <body> as parent
      }

      this.init();

      this.initStickyObservers();

      // Bundles: the bar may connect (or be re-rendered) after the seeds block
      // already synced, so pull the current bundle ATC state now.
      const seedsEl = this.scopeEl().querySelector(`nss-buybox-seeds`);
      if (seedsEl && typeof seedsEl.syncStickyAtc === `function`) {
        seedsEl.syncStickyAtc();
      }

      this.addEventListener(`click`, this.handleClick.bind(this));
      this.addEventListener(`buyboxUpdate`, this.handleUpdate.bind(this));

      window.matchMedia(`(max-width: 989px)`).addEventListener(`change`, () => {
        this.syncBodyClass();
      });
      // this.addEventListener(`buyboxReload`, this.reloadHandler.bind(this));
    }

    scopeEl() {
      if (this.sectionEl && this.sectionEl.isConnected) return this.sectionEl;
      return this.closest(`[id^="shopify-section"]`) || document;
    }

    async fetchSection() {
      const parser = new DOMParser();
      const sectionID = this.getAttribute(`nss-parent-section-id`);
      const markup = await (await fetch(`?section_id=${sectionID}`)).text();
      const dom = parser.parseFromString(markup, "text/html");
      return dom;
    }

    async reloadHandler() {
      const dom = await this.fetchSection();

      const selectorParent = `nss-buybox-sticky-atc-variant[nss-variant-id="${this.variantId}"]`;
      const selectorChild = `.nss-buybox-sticky-atc__inner`;
      const selector = `${selectorParent} ${selectorChild}`;
      const newAtc = dom.querySelector(selector);
      const thisAtc = this.querySelector(selectorChild);
      thisAtc.replaceWith(newAtc);

      this.init();
    }

    handleClick(e) {
      if (this.debug) console.log(`[NSS][Buybox Sticky ATC] Click - e.target:`, e.target);

      if (e.target.closest(`[nss-sticky-scroll]`)) {
        e.preventDefault();
        const target =
          document.querySelector(`nss-buybox`) ||
          document.querySelector(`nss-buybox-panes`);
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: `smooth`, block: `start` });
        }
        return;
      }

      if (e.target.closest(`[nss-add-to-cart-btn]`)) {
        const scope = this.scopeEl();
        const formEl = scope.querySelector(
          `[nss-variant-id="${this.variantId}"] .shopify-product-form`
        );
        if (formEl) {
          formEl.requestSubmit();
          return;
        }
        const bundleBtn = scope.querySelector(`[nss-bundle-add-to-cart]`);
        if (bundleBtn) bundleBtn.click();
      }
    }

    // Optional delay marker: when [data-delay-sticky-bar] exists anywhere on
    // the page, the bar stays hidden until the visitor scrolls PAST that
    // element. The marker can be a real attribute, or the literal text
    // "data-delay-sticky-bar" / "[data-delay-sticky-bar]" typed inside any
    // text content — the token is stripped from the display and its parent
    // element becomes the target. No marker on the page = current behavior.
    findDelayTarget() {
      const attrEl = document.querySelector(
        `[data-delay-sticky-bar]:not(nss-buybox-sticky-atc-variant)`
      );
      if (attrEl) return attrEl;

      const token = `data-delay-sticky-bar`;
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue || node.nodeValue.indexOf(token) === -1) continue;
        const el = node.parentElement;
        if (!el || el.closest(`script, style`)) continue;
        node.nodeValue = node.nodeValue.replace(`[${token}]`, ``).replace(token, ``);
        el.setAttribute(token, ``);
        return el;
      }
      return null;
    }

    initStickyObservers() {
      const scope = this.scopeEl();
      const controlsEls = scope.querySelectorAll(`.nss-buybox__atc`);
      const footerEl = document.querySelector(`nss-footer`);

      this.atcVisible = true;
      this.footerInView = false;
      // Setting-driven switch (block checkbox outputs data-delay-sticky-bar
      // on this element): directional reveal — the bar shows only after the
      // visitor scrolls PAST the trigger, never while still above it. The
      // trigger is the buybox ATC by default, or an optional page marker.
      const delayEnabled = this.hasAttribute(`data-delay-sticky-bar`);
      this.delayEl = delayEnabled ? this.findDelayTarget() : null;
      this.delayPassed = !this.delayEl;
      this.atcAbove = false;

      const update = () => {
        const gate = delayEnabled ? this.atcAbove && this.delayPassed : true;
        if (!this.atcVisible && !this.footerInView && gate) {
          this.showStickyBar();
        } else {
          this.hideStickyBar();
        }
      };

      if (this.delayEl) {
        const delayObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.delayPassed =
                !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            });
            update();
          },
          { root: null, threshold: 0 }
        );
        delayObserver.observe(this.delayEl);
      }

      const controlsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.boundingClientRect.height === 0) return;
            this.atcVisible = entry.isIntersecting;
            this.atcAbove =
              !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          });
          update();
        },
        { root: null, threshold: 0 }
      );
      controlsEls.forEach((controlsEl) => controlsObserver.observe(controlsEl));

      if (footerEl) {
        const footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.footerInView = entry.isIntersecting;
            });
            update();
          },
          { root: null, threshold: 0.1 }
        );
        footerObserver.observe(footerEl);
      }
    }

    showStickyBar() {
      this.classList.add(`nss-open`);
      // this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `100px`);
      this.syncBodyClass();
    }

    hideStickyBar() {
      this.classList.remove(`nss-open`);
      // this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `0px`);
      this.syncBodyClass();
    }

    // Mirrors the bar's visibility (.nss-active = current variant, .nss-open =
    // slid into view) onto <body> so page CSS can react to the sticky bar.
    // Mobile-only: nss-sticky-atc-visible marks <body> while a bottom bar
    // (buybox sticky ATC or sticky CTA) is on screen at 989px or less.
    syncBodyClass() {
      const mobile = window.matchMedia(`(max-width: 989px)`).matches;
      const barVisible = !!document.querySelector(
        `nss-buybox-sticky-atc-variant.nss-active.nss-open, nss-sticky-cta.nss-open`
      );
      document.body.classList.toggle(`nss-sticky-atc-visible`, mobile && barVisible);
    }

    handleUpdate(e) {
      const oldId = e.detail.oldId;
      const newId = e.detail.newId;

      const scope = this.closest(`nss-buybox`) || this.scopeEl();
      if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
        return;
      }

      if (newId === this.variantId) {
        if (this.debug) console.log(`[NSS][Buybox Sticky ATC] handleUpdate e.detail:`, e.detail);
        this.classList.add(`nss-active`);
      } else {
        this.classList.remove(`nss-active`);
      }
      this.syncBodyClass();

      if (newId === this.variantId && oldId === newId) {
        if (this.debug)
          console.log(
            `[NSS][Buybox Sticky ATC] handleUpdate e.detail.quantity:`,
            e.detail.quantity
          );
        if (e.detail.quantity !== null) {
          this.els.qtyItems.forEach((qtyItemEl) => {
            const count = qtyItemEl.getAttribute(`nss-sticky-qty-item-count`);
            const total = count * parseInt(e.detail.quantity);
            qtyItemEl.innerHTML = total;
          });
        }

        if (this.debug)
          console.log(
            `[NSS][Buybox Sticky ATC] handleUpdate e.detail.sellingPlanId:`,
            e.detail.sellingPlanId
          );
        if (e.detail.sellingPlanId !== null) {
          this.els.frequencyItems.forEach((frequencyItemEl) => {
            frequencyItemEl.classList.remove(`nss-active`);
          });
          const updateFrequencyEls = this.querySelectorAll(
            `[nss-frequency-update="${e.detail.sellingPlanId}"]`
          );
          updateFrequencyEls.forEach((updateFrequencyEl) => {
            updateFrequencyEl.classList.add(`nss-active`);
          });
        }

        if (this.els.atcBtn) {
          const atcSpanEl = this.els.atcBtn.querySelector(`span`);
          // let atcText = "ADD TO CART";
          // if (e.detail.sellingPlanId !== "") {
          //   atcText = this.els.atcBtn.getAttribute(`nss-atc-sub-text`);
          // } else {
          //   atcText = this.els.atcBtn.getAttribute(`nss-atc-otp-text`);
          // }
          // atcSpanEl.innerHTML = atcText;
        }
      }
    }
  }

  customElements.define(elementName, NSSBuyboxStickyATC);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
